// src/components/HamburgerMenu.tsx

import React from "react";
import TabDropdownList from "./TabDropdownList";
import { useHamburgerMenu } from "../contexts/HamburgerMenuContext";

const HamburgerMenu: React.FC = () => {
  const { isHamburgerMenuOpen } = useHamburgerMenu();

  return (
    <div
      className={`hamburger-menu ${
        isHamburgerMenuOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* Navigation Tabs */}
      <nav>
        <TabDropdownList />
      </nav>
    </div>
  );
};

export default HamburgerMenu;
